<template>
  <div>
    <IdleScreen />
    <transition name="screen" mode="out-in">
      <MakeWordScreen key="MAKE_WORD_SCREEN" v-if="activeGameAreaScreen == 'MAKE_WORD_SCREEN'" />
      <TradeCardScreen key="INITIATE_TRADE_SCREEN" v-else-if="activeGameAreaScreen == 'INITIATE_TRADE_SCREEN'" />
      <MakeWordCongratulatoryScreen key="WORD_CONGRATULATORY_SCREEN" v-else-if="activeGameAreaScreen == 'WORD_CONGRATULATORY_SCREEN'" />
    </transition>
  </div>
</template>

<script setup lang="ts">
import IdleScreen from '@/components/screens/game-play/game-area/IdleScreen.vue'
import MakeWordScreen from '@/components/screens/game-play/game-area/MakeWordScreen.vue'
import TradeCardScreen from '@/components/screens/game-play/game-area/TradeCardScreen.vue'
import MakeWordCongratulatoryScreen from '@/components/screens/game-play/game-area/MakeWordCongratulatoryScreen.vue'
import { useGameArea } from '@/composables/useGameArea'
import { useGameStore } from '@/stores/game'
import type { CardCategoryT, CardT } from '@/types/Game'
import { storeToRefs } from 'pinia'
import { onBeforeUnmount, onMounted, watch } from 'vue'

const { activeGameAreaScreen, setActiveGameAreaScreen, cardToTrade, tradeCardType, tradeLetter, resetTradeSwap } = useGameArea()
const { gameState, playStatus, isTurn } = storeToRefs(useGameStore())
const { getCardById } = useGameStore()

const initTradeOffer = () => {
  tradeCardType.value = gameState.value!.activeTrade?.targetCategory as CardCategoryT
  tradeLetter.value = gameState.value!.activeTrade?.targetLetter as string
  cardToTrade.value = getCardById(gameState.value!.activeTrade!.swapCardId) as CardT
  setActiveGameAreaScreen('INITIATE_TRADE_SCREEN')
}

watch(isTurn, val => {
  if (!val) {
    setActiveGameAreaScreen('IDLE_SCREEN')
    tradeCardType.value = 'plan'
    resetTradeSwap()
    cardToTrade.value = null
  }
})

onMounted(() => {
  if (playStatus.value === 'offering_trade' && isTurn.value) {
    initTradeOffer()
  } else {
    activeGameAreaScreen.value = 'IDLE_SCREEN'
    cardToTrade.value = null
    tradeCardType.value = 'plan'
    resetTradeSwap()
  }
})

onBeforeUnmount(() => {
  activeGameAreaScreen.value = 'IDLE_SCREEN'
  tradeCardType.value = 'plan'
})
</script>
